// FixMembershipIDs.js - Admin utility page
import React, { useState } from 'react';
import Button from '../../components/ui/Button';
import { fixAllMembershipIDs, fixUserMembershipID } from '../../utils/fixMembershipID';
import useAuth from '../../hooks/useAuth';

const FixMembershipIDs = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [userIdInput, setUserIdInput] = useState('');

  const handleFixAll = async () => {
    if (!window.confirm('This will check and fix all users\' membership IDs. Continue?')) {
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const results = await fixAllMembershipIDs();
      setResult({
        type: 'success',
        message: 'Fix completed',
        details: results
      });
    } catch (error) {
      setResult({
        type: 'error',
        message: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFixSingle = async () => {
    const userId = userIdInput.trim() || user?.uid;
    if (!userId) {
      alert('Please enter a user ID or login');
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const result = await fixUserMembershipID(userId);
      setResult({
        type: result.success ? 'success' : 'error',
        message: result.message,
        details: { membershipID: result.membershipID }
      });
    } catch (error) {
      setResult({
        type: 'error',
        message: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Fix Membership IDs</h1>
      
      <div style={{ marginBottom: '30px', padding: '15px', background: '#f0f0f0', borderRadius: '5px' }}>
        <p><strong>This utility will:</strong></p>
        <ul>
          <li>Check all users for missing or incorrectly named membership ID fields</li>
          <li>Fix field casing (membershipId → membershipID)</li>
          <li>Generate new IDs for users without one</li>
        </ul>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Fix Single User</h3>
        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
          <input
            type="text"
            placeholder={user?.uid || "Enter User ID"}
            value={userIdInput}
            onChange={(e) => setUserIdInput(e.target.value)}
            style={{ 
              flex: 1, 
              padding: '10px', 
              border: '1px solid #ccc', 
              borderRadius: '4px' 
            }}
          />
          <Button onClick={handleFixSingle} disabled={loading}>
            Fix User
          </Button>
        </div>
        <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
          Leave empty to fix your own account
        </p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Fix All Users</h3>
        <Button onClick={handleFixAll} disabled={loading} variant="primary">
          {loading ? 'Processing...' : 'Fix All Users'}
        </Button>
      </div>

      {result && (
        <div style={{ 
          padding: '15px', 
          marginTop: '20px', 
          borderRadius: '5px',
          backgroundColor: result.type === 'success' ? '#d4edda' : '#f8d7da',
          borderLeft: `4px solid ${result.type === 'success' ? '#28a745' : '#dc3545'}`
        }}>
          <h4 style={{ margin: '0 0 10px 0' }}>{result.message}</h4>
          {result.details && (
            <pre style={{ 
              backgroundColor: 'white', 
              padding: '10px', 
              borderRadius: '4px',
              overflow: 'auto'
            }}>
              {JSON.stringify(result.details, null, 2)}
            </pre>
          )}
        </div>
      )}
    </div>
  );
};

export default FixMembershipIDs;
